import { Component, Input, OnInit } from '@angular/core';
import { ParamMap } from '@angular/router';

import { AppConfig } from '®shared/config/index';

import { LtiAlertTypes } from './lti-alert-types';

@Component({
  selector: 'rl-lti-alert',
  templateUrl: './lti-alert.component.html',
})
export class LtiAlertComponent implements OnInit {
  @Input() paramMap: ParamMap;

  constructor(private appConfig: AppConfig) {}

  ALERT_BEST_MATCHED_LIST = $localize`:@@ltiAlert-bestMatchedList:The list selected is based on automated matching, if this is not what you expected 'Embed a different list'`;
  ALERT_NO_MATCHED_LIST = $localize`:@@ltiAlert-noMatchedList:Our automated matching has not found a list which is an exact match, here are some suggestions, or you can search for an alternative list`;
  ALERT_CURRENTLY_LINKED_LIST = $localize`:@@ltiAlert-currentlyLinkedList:Based on your selection this list has now been embedded successfully`;
  ALERT_MOST_RECENT_RESOLUTION = $localize`:@@ltiAlert-notExactMatch:You have been redirected to the most recent version of this list`;

  i18nMessage: string = null;

  ngOnInit(): void {
    if (this.paramMap) {
      if (this.paramMap.has(LtiAlertTypes.ALERT_BEST_MATCHED_LIST)) {
        this.i18nMessage = this.ALERT_BEST_MATCHED_LIST;
      } else if (this.paramMap.has(LtiAlertTypes.ALERT_NO_MATCHED_LIST)) {
        this.i18nMessage = this.ALERT_NO_MATCHED_LIST;
      } else if (this.paramMap.has(LtiAlertTypes.ALERT_CURRENTLY_LINKED_LIST)) {
        this.i18nMessage = this.ALERT_CURRENTLY_LINKED_LIST;
      }
    }

    if (
      this.appConfig?.session?.lti1p3LaunchType === 'deep_link' &&
      this.appConfig?.session?.lti1p3LinkResolutionDetails ===
        'most_recent_resolution'
    ) {
      this.i18nMessage = this.ALERT_MOST_RECENT_RESOLUTION;
    }
  }
}
